<script setup lang="ts">
import type { ComponentStyles, HeroContentResponseContent } from 'types';

defineProps<{
  data: HeroContentResponseContent;
  componentStyles?: ComponentStyles;
}>();
</script>

<template>
  <BaseComponentWrapper>
    <BaseHero :data="data.heroList" />
  </BaseComponentWrapper>
</template>
